export default __webpack_public_path__ + "static/media/1398.30b08b9b.png";